<template>
    <div class="te-token">
        <div class="te-token-label">{{languageSettings.tokenLabel}}</div>
        <div class="te-token-input">
            <input class="te-form-control te-token__code" type="text" name="token" v-model="token" :placeholder="languageSettings.tokenPlaceholder">
            <div class="te-token__add">
                <button class="te-button te-primary-action" data-cy="add-token" @click="addToken">{{languageSettings.addToken}}</button>
            </div>
        </div>
        <div v-if="getAddedTokens(order)" class="te-token-added">
            <span class="te-token-added__label">{{languageSettings.tokenAddedLabel}}</span>
            <span class="te-token-added__tokens">{{getAddedTokens(order)}}</span>
        </div>
    </div>
</template>

<script>
    import { mapActions } from "vuex";
    import {IsInFinalState} from "ticketengine-checkout-sdk";

    export default {
        name: "Coupon",

        data() {
            return {
                token: null,
            };
        },

        props: {
            order: {
                type: Object,
                // required: true
            },
            language: {
                type: Object
            },
        },

        computed: {
            // ...mapGetters({
            //     order: 'order',
            // }),

            canAddToken: function() {
                // return !this.order || (this.order && this.order.tokens === null)
                return true
            },

            // addedTokens: function() {
            //     return this.order && this.order.tokens !== null ? this.order.tokens.map(t => t.token).join(', ') : null;
            // },

            languageSettings: function() {
                const defaultSettings = {
                    addToken: 'Add',
                    tokenLabel: 'Enter your coupon code',
                    tokenPlaceholder: 'Coupon code',
                    tokenAddedLabel: 'Added coupons:',
                };
                return Object.assign(defaultSettings, this.language);
            },
        },

        methods: {
            ...mapActions([
                "addOrderToken"
            ]),

            async addToken() {
                if(this.token !== null && this.token !== '') {
                    await this.addOrderToken({
                        token: this.token
                    });
                    this.token = null;
                }
            },

            getAddedTokens(order) {
                const isInFinalState = new IsInFinalState();
                return order && !isInFinalState.validate(order) && order.tokens !== null ? order.tokens.map(t => t.token).join(', ') : null;
            },

        },

        created() {

        }
    }
</script>

<style scoped>

</style>
